module.exports = __webpack_public_path__ + "img/icon-fzsb.4885e843.png";